import React, {useEffect, useRef} from 'react';

import {createZoomImageHover} from '@zoom-image/core';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {getCloudinaryURL} from 'libs/cloudinary/cloudinary';

import s from './baseItemImageZoom.scss';

type PropsType = {
    img: string;
    alt: string;
    height?: number;
    width?: number;
};

/**
 * Component which adds cart items zoom functionality
 */
export const BaseItemImageZoom = ({alt, height = 130, img, width = 260}: PropsType) => {
    const imageHoverContainerRef = useRef<HTMLDivElement>(null);
    const zoomTargetRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const imageContainer = imageHoverContainerRef.current as HTMLDivElement;
        const zoomTarget = zoomTargetRef.current as HTMLDivElement;
        createZoomImageHover(imageContainer, {
            customZoom: {height: 200, width: 400},
            disableScrollLock: true,
            scale: 4.6,
            zoomImageSource: getCloudinaryURL(img),
            zoomLensClass: s.zoomLens,
            zoomTarget,
            zoomTargetClass: s.zoomTargetActive,
        });
    }, [img, width, height]);

    return (
        <div className={s.imageHoverContainer} ref={imageHoverContainerRef}>
            <CloudinaryImage alt={alt} className={s.img} src={getCloudinaryURL(img)} />
            <div className={s.zoomTarget} ref={zoomTargetRef} />
        </div>
    );
};
